import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import helper from '../../../utilities/helper';
import { TAB_ENUM } from '../../Page/SelfCarePage/Constant';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {getCustomerServicesAvailableToRedirect, setUserMobileNumbersRedirect} from './RedirectBoxSlice';
import images from './images/images';
import Config from '../../../Config';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import './RedirectBox.scss';
import OtpVerificationPageWithImage from '../../Shared/OtpAuthentication/OtpVerificationPageWithImage';
import {setUserMobileNumbers} from '../../Block/GenericVASBlock/GenericVasSlice';
import {isMobile} from 'react-device-detect';
import {otpOrigin} from '../OTPLoginBlock/Assets/variables';

function RedirectBox({
  context,
  iContent,
  userMobileNumbers,
  fatalError,
  getCustomerServicesAvailableToRedirect,
  setUserMobileNumbersRedirect,
  showAppLoader,
  hideAppLoader,
  isFullAuthenticated,
  otpAuthentication,
  contactNumber,
  authentication,
  selectedSubscriber,
}) {
  const goTo = iContent.baseUrl.value;
  const queryString = '?sub=';
  const [isLoading, SetIsLoading] = useState(true);
  const [isOtpAuthentication, SetIsOtpAuthentication] = useState(false);

  useEffect(() => {
    if (authentication.isAuthenticateFinish) {
      initPage();
    }
  }, [authentication.isAuthenticateFinish]);

  function initPage() {
    //console.info('initPage - authentication', authentication);
    if (
      authentication.loginData.isFullAuthenticated ||
      authentication.loginData.isOtpAuthenticated ||
      authentication.loginData.isOtpExtendedAuthenticated
    ) {
      SetIsOtpAuthentication(false);

      const isComeFromLobbyPage = helper.isComeFromSelfCarePage( [TAB_ENUM.Cellular , TAB_ENUM.Abroad ]);

      //Check if user already choose subscriber from selfcare lobby
      if (isComeFromLobbyPage && selectedSubscriber) {
        setUserMobileNumbersRedirect(selectedSubscriber);
        return;
      }

      //Check if user already authenticated by Otp
      if (authentication.loginData.isOtpAuthenticated) {
        showAppLoader();
        SetIsLoading(false);
        hideAppLoader();
        setUserMobileNumbersRedirect(contactNumber);
        return;
      }

      //Check if user already full authenticated
      if (authentication.loginData.isFullAuthenticated || authentication.loginData.isOtpExtendedAuthenticated) {
        async function getItems() {
          showAppLoader();
          await getCustomerServicesAvailableToRedirect();
          SetIsLoading(false);
          hideAppLoader();
        }
        getItems();
        return;
      }
    } else {
      //start otp authentication flow
      SetIsOtpAuthentication(true);
    }
  }

  useEffect(() => {
    return () => {
      hideAppLoader();
    };
  }, [fatalError]);

  //Effect if user authenticated
  //If user has 1 mobile number we redirect the user with subscriberNo
  //Else we give the user the option to choose
  useEffect(() => {
    if (userMobileNumbers.length == 1) {
      let subscriberNo = selectedSubscriber ? selectedSubscriber : contactNumber;
      const redirectToPageUrl = iContent.baseUrl ? iContent.baseUrl.value + queryString + subscriberNo : '';
      window.location.replace(redirectToPageUrl);
    }
  }, [userMobileNumbers]);

  function redirect(number) {
    // showAppLoader();
    window.location.assign(goTo + queryString + number);
  }

  function goBackHome() {
    window.location.assign(Config.lobbyUrl);
  }

  function errorDisplay() {
    return isLoading == false && userMobileNumbers && userMobileNumbers.length == 0 ? (
      <div className='redirectBox-container'>
        <div className='headers-row'>
          {isLoading == false && fatalError == true ? (
            <h3 className='top-header'>רגע! זה היה לא צפוי, יש לנו תקלה</h3>
          ) : (
            <h3 className='top-header'>רק שנייה אנחנו מזהים שאין לכם מנוי סלולר</h3>
          )}
        </div>
        <div>
          <p>אם תרצו לדבר איתנו אנחנו זמינים ב*3132</p>
        </div>
        <Image style={{marginBottom: '20px', marginTop: '10px'}} src={images.error} alt='error' />
        <div style={{marginTop: '20px'}} className='btn-row'>
          <BtnSubmit text='הבנתי' onclick={() => goBackHome()} />
        </div>
      </div>
    ) : null;
  }

  function displayMobileBox() {
    if (userMobileNumbers && userMobileNumbers.length == 1) {
      return (
        <div className='loader-container'>
          <Loader />
        </div>
      );
    }
    return userMobileNumbers.map((item) => (
      <div key={item.subscriberNo} onClick={() => redirect(item.subscriberNo)} className='mobileBox'>
        {item.subscriberNo}
        <div className='arrow' onClick={() => redirect(item.subscriberNo)}></div>
      </div>
    ));
  }

  let epiTitle, otpBanner, otpBannerMainTitle, otpBannerSecondTitle, blockSource;
  if (iContent.otp?.value?.length > 0 && iContent.otp.expandedValue) {
    epiTitle = iContent.otp.expandedValue[0]?.stepOneTitle?.value;
    otpBanner = isMobile ? iContent.otp.expandedValue[0]?.imageMobile?.value : iContent.otp.expandedValue[0]?.imageDesktop?.value;
    otpBannerMainTitle = isMobile
      ? iContent.otp?.expandedValue[0]?.bannerMainTitleMobile?.value
      : iContent.otp?.expandedValue[0]?.bannerMainTitleDesktop?.value;

    otpBannerSecondTitle = isMobile
      ? iContent.otp?.expandedValue[0]?.bannerSecondTitleMobile?.value
      : iContent.otp?.expandedValue[0]?.bannerSecondTitleDesktop?.value;
    blockSource = iContent.otp?.expandedValue[0]?.blockSource?.value;
  }

  const otpTitles = {
    bannerMainTitle: otpBannerMainTitle,
    bannerSecondTitle: otpBannerSecondTitle,
    verifyPhoneTitle: epiTitle,
    phoneStepButtonText: 'שלחו לי קוד אימות',
    verifyPhoneDescription: 'מה מספר הנייד שלכם?',
    verifyCodeTitle: 'שלחנו קוד אימות, הגיע?',
    otpCodeStepButtonText: 'המשך',
    verifyCodeDescription: 'הקלידו את הקוד שקיבלתם בהודעה',
    blockSource: blockSource,
  };

  return (
    <>
      {isOtpAuthentication ? (
        <div className='redirectBox-container-otp'>
          <div className={`${!epiTitle ? 'pt-5' : ''} m-auto`}>
            <OtpVerificationPageWithImage
              originProcess={blockSource}
              otpOrigin={otpOrigin.GENERIC}
              otpTitles={otpTitles}
              isInline={false}
              otpBanner={otpBanner}
              isRedirectBox={true}
              onAuthenticatedAction={initPage}
            />
          </div>
        </div>
      ) : isLoading == false && userMobileNumbers && userMobileNumbers.length > 0 && fatalError != true ? (
        <div className='redirectBox-container customer-list'>
          <div className='headers-row'>
            {userMobileNumbers && userMobileNumbers.length == 1 ? null : <h3 className='top-header'>על איזה מנוי מדובר?</h3>}
          </div>
          <div className='mobile-data-row'>{displayMobileBox()}</div>
        </div>
      ) : (
        errorDisplay()
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  userMobileNumbers: state.redirectBoxBlock.userMobileNumbers,
  fatalError: state.redirectBoxBlock.fatalError,
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  otpAuthentication: state.authentication.loginData.isOtpAuthenticated,
  contactNumber: state.authentication.loginData.userDetails.contactNumber,
  authentication: state.authentication,
  selectedSubscriber: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
});

const mapDispatchToProps = {
  getCustomerServicesAvailableToRedirect,
  showAppLoader,
  hideAppLoader,
  setUserMobileNumbers,
  setUserMobileNumbersRedirect,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedirectBox);
